// extracted by mini-css-extract-plugin
export default {"ButtonLink":"ButtonLink_ButtonLink__4FRq4"};